import { MouseEvent } from 'react';

const FOCUS_SKIP_SELECTOR =
  'a, button, input, textarea, select, [role="button"], [role="option"], [contenteditable="true"]';

const TEXT_SELECTION_SELECTOR = '[data-rachel-text-selection="true"]';

let focusHandler: (() => void) | null = null;

export const registerRachelInputFocus = (handler: (() => void) | null) => {
  focusHandler = handler;
};

const canFocus = (event: MouseEvent<HTMLElement>) => {
  const target = event.target as HTMLElement | null;

  return !!target && !target.closest(FOCUS_SKIP_SELECTOR);
};

const isInTextSelectionArea = (event: MouseEvent<HTMLElement>) =>
  !!(event.target as HTMLElement | null)?.closest(TEXT_SELECTION_SELECTOR);

export const focusRachelInputOnMouseDown = (event: MouseEvent<HTMLElement>) => {
  if (!canFocus(event) || isInTextSelectionArea(event)) {
    return;
  }

  event.preventDefault();
  focusHandler?.();
};

export const focusRachelInputOnClick = (event: MouseEvent<HTMLElement>) => {
  if (!canFocus(event) || !isInTextSelectionArea(event)) {
    return;
  }

  if (!window.getSelection()?.isCollapsed) {
    return;
  }

  focusHandler?.();
};
